import { render, staticRenderFns } from "./Double12_2020.vue?vue&type=template&id=04738382&scoped=true&"
import script from "./Double12_2020.vue?vue&type=script&lang=js&"
export * from "./Double12_2020.vue?vue&type=script&lang=js&"
import style0 from "./Double12_2020.vue?vue&type=style&index=0&id=04738382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04738382",
  null
  
)

export default component.exports